export default function objToParams(obj) {
  if (!obj) return '';

  return `?${Object
    .keys(obj)
    .filter(key =>
      obj[key] !== '' && (!Array.isArray(obj[key]) || (typeof obj[key][0] !== 'undefined')), // remove empty strings and arrays
    )
    .map(key => (Array.isArray(obj[key]) ?
      `${key}=${encodeURIComponent(obj[key].join(','))}` :
      `${key}=${encodeURIComponent(obj[key])}`))
    .join('&')}`;
}